<template>
    <GetStartedLayout
        :errors="errors"
        :breadcrumbs="['Home', 'Gifts']"
        :guest="guest"
        :review="review"
        hideFab
        :helpForm="false"
        :location="$page.props.auth?.user?.selected_location ?? null"
    >
        <v-col cols="12" md="10" lg="8">
            <v-card class="soli-round">
                <v-container>
                    <v-card-title class="font-weight-bold soli-grey text-h4">
                        Gifts
                    </v-card-title>
                    <v-card-subtitle
                        >Give experience and knowledge that will last a
                        lifetime</v-card-subtitle
                    >
                    <v-form
                        @submit.prevent="purchaseGiftCard"
                        ref="giftCardForm"
                    >
                        <v-list>
                            <v-row class="px-3">
                                <v-col
                                    cols="12"
                                    sm="5"
                                    class="flex justify-center align-center"
                                    :class="
                                        $vuetify.breakpoint.xs ? null : 'pr-1'
                                    "
                                >
                                    <v-img
                                        class="soli-round"
                                        :src="
                                            [10, 11].includes(moment().month())
                                                ? 'gift-cards-holidays.webp'
                                                : 'gift-cards-white.webp'
                                        "
                                    ></v-img
                                ></v-col>
                                <v-col
                                    cols="12"
                                    sm="7"
                                    :class="
                                        $vuetify.breakpoint.xs ? 'pa-0' : 'pl-1'
                                    "
                                >
                                    <v-btn-toggle
                                        v-model="giftCardForm.price"
                                        mandatory
                                        dense
                                        class="w-full"
                                    >
                                        <v-col cols="12" class="pa-0 ma-0">
                                            <v-list-item-title
                                                class="font-weight-bold soli-grey pa-4"
                                                >Select a gift
                                                amount:</v-list-item-title
                                            >
                                            <v-list-item
                                                v-for="option in options"
                                                :key="option.amount"
                                            >
                                                <SoliBtn
                                                    block
                                                    :text="
                                                        formatUnitAmount(
                                                            option.amount
                                                        )
                                                    "
                                                    :value="option"
                                                    color="soli-grey"
                                                    outlined
                                                ></SoliBtn>
                                            </v-list-item>
                                        </v-col>
                                    </v-btn-toggle> </v-col
                            ></v-row>
                        </v-list>
                        <v-container class="my-3" style="max-width: 600px">
                            <SoliText
                                v-if="$page.props.auth.user"
                                v-model="giftCardForm.email"
                                :errors="errors.email"
                                :rules="rules.email"
                                hideDetails
                                icon="alternate_email"
                                label="Your email"
                                class="my-3"
                            ></SoliText>
                            <SoliBtn
                                class="my-3"
                                gradient="gradient-orange"
                                type="submit"
                                text="Buy Now"
                                block
                                :loading="giftCardFormLoading"
                                :disabled="
                                    $page.props.auth.user
                                        ? !giftCardForm.email
                                        : false
                                "
                            ></SoliBtn>
                            <small
                                class="flex justify-center soli-grey mt-1 px-4"
                                >Printable certificate, good for services at any
                                Musicologie location.</small
                            >
                        </v-container>
                    </v-form></v-container
                >
            </v-card></v-col
        >
        <div class="soli-round" v-if="viewReceipt !== null">
            <v-dialog
                v-model="viewReceipt"
                persistent
                :fullscreen="$vuetify.breakpoint.xs ? true : false"
                :content-class="$vuetify.breakpoint.xs ? '' : 'soli-round'"
                :transition="
                    $vuetify.breakpoint.smAndDown
                        ? 'dialog-bottom-transition'
                        : 'dialog-transition'
                "
                max-width="600px"
            >
                <v-card>
                    <v-btn
                        icon
                        @click="viewReceipt = false"
                        class="ma-3 soli-close soli-grey soli-text-shadow"
                        ><v-icon>clear</v-icon></v-btn
                    >
                    <v-card-title>Thank you!</v-card-title>
                    <v-card-subtitle>Here's your receipt</v-card-subtitle>
                    <v-container class="pt-0">
                        <v-list v-if="successData?.giftCard">
                            <v-list-item>
                                Email: {{ successData.giftCard.customer_email }}
                                <br />
                                Amount:
                                {{
                                    formatUnitAmount(
                                        successData.giftCard.amount
                                    )
                                }}
                                <br />
                                Payment: {{ successData.giftCard.last4 }}
                                <br />
                                Redemption Code:
                                {{ successData.giftCard.code }}</v-list-item
                            >
                            <br />
                            <v-img :src="successData.giftCard.img_url"></v-img>
                        </v-list> </v-container></v-card
            ></v-dialog>
        </div>
    </GetStartedLayout>
</template>

<script>
import GetStartedLayout from "./../Layouts/GetStartedLayout";
import "../../../Plugins/fbPixel.js";

export default {
    components: {
        GetStartedLayout,
    },
    props: ["errors", "options", "review", "guest", "successData"],
    data() {
        return {
            eventsLoading: false,
            giftCardFormLoading: false,
            giftCardForm: {
                price: null,
                email: this.$page.props.auth.user
                    ? this.$page.props.auth.user.email
                    : null,
                img_url: null,
                code: null,
            },
            viewReceipt: this.successData?.giftCard ?? false,
            rules: {
                email: [
                    (v) => !!v || "E-mail is required",
                    (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
                ],
            },
        };
    },
    methods: {
        purchaseGiftCard() {
            if (!this.$refs.giftCardForm.validate()) return;
            this.giftCardFormLoading = true;
            this.$inertia.get(route("gift.create"), this.giftCardForm, {
                onSuccess: () => {
                    try {
                        fbq(
                            "track",
                            "Lead",
                            { currency: "USD", value: 200 },
                            { eventID: `Lead-gifts-${this.giftCardForm.email}` }
                        );
                    } catch (e) {
                        console.log(e.message);
                    }
                },
                onError: (errors) => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(this.errors)
                    );
                    this.giftCardFormLoading = false;
                },
            });
        },
    },
};
</script>

<style></style>
